
import { AxiosAPI } from '../helpers/AxiosAPI';
import { postAPI_SaveUsersAuditLogs } from '../constants/APIs';

export async function SaveAuditLogs(body) {
    const formmatedData = {
        groupId: body.groupId,
        itemId: body.itemId,
        action: body.action,
        content: body.content,
        logType: body.logType,
        createdBy: body.createdBy
    }
    await AxiosAPI({
        method: 'post',
        data: formmatedData,
        url: `${postAPI_SaveUsersAuditLogs}`,
    })
        .then(async (res) => {
            console.log("auditsave");
        });
};